import React from "react";
import "./Stepper.css";

export default function Stepper(props) {
  const pages = [
    { id: 1, name: "page 1" },
    { id: 2, name: "page 2" },
    { id: 3, name: "page 3" },
    { id: 4, name: "page 4" },
  ];

  return (
    <div className="dotsGroup centeredFlex">
      {pages.map((page) => (
        <div
          key={page.id}
          className={`dot ${page.id === props.step ? "activeStep" : ""}`}
        ></div>
      ))}
    </div>
  );
}

